import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Mail, UserPlus, Upload, Loader2 } from 'lucide-react';

export const InviteTab = ({
  inviteEmails, setInviteEmails,
  onInvite, inviting,
  onCSVImport, importing,
}) => (
  <Card className="p-6  bg-[var(--isp-glass)] backdrop-blur-xl border-[var(--isp-glass-border)]">
    <h3 className="text-lg font-semibold text-[var(--isp-heading)] mb-4 flex items-center gap-2">
      <Mail className="w-5 h-5 text-blue-400" />
      Invite Members
    </h3>
    <p className="text-sm text-[var(--isp-body)] mb-4">Enter email addresses (comma or newline separated)</p>
    <textarea
      value={inviteEmails}
      onChange={e => setInviteEmails(e.target.value)}
      placeholder={"student1@university.edu\nstudent2@university.edu"}
      rows={5}
      className="w-full p-4 rounded-xl bg-[var(--isp-glass-inner)] border border-[var(--isp-glass-border)] text-white text-sm resize-none"
      data-testid="invite-emails-input"
    />
    <div className="flex gap-3 mt-4">
      <Button
        onClick={onInvite}
        disabled={inviting}
        className="rounded-xl gap-2 bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600"
        data-testid="send-invites-btn"
      >
        {inviting ? <Loader2 className="w-4 h-4 animate-spin" /> : <UserPlus className="w-4 h-4" />}
        Send Invitations
      </Button>
      <label className="cursor-pointer">
        <input type="file" accept=".csv" onChange={onCSVImport} className="hidden" data-testid="csv-import-input" />
        <div className="flex items-center gap-2 px-4 py-2 rounded-xl bg-amber-500/20 border border-amber-500/30 text-amber-300 text-sm font-medium hover:bg-amber-500/30 h-full">
          {importing ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
          Import CSV
        </div>
      </label>
    </div>
  </Card>
);
